<template>
<sui-page>
  <sui-page-header title="Confirm"></sui-page-header>
  <sui-page-contents>
    <div class="mr15">
      <div>
        <button class="mybtn" @click="onClickSuccess">Success</button>
        <button class="mybtn" @click="onClickWarning">Warning</button>
        <button class="mybtn" @click="onClickError">Error</button>
        <button class="mybtn" @click="onClickErrorLog">ErrorLog</button>
        <button class="mybtn" @click="onClickInformation">Information</button>
        <button class="mybtn" @click="onClickConfirm">Confirm</button>
        <button class="mybtn" @click="onClickLink">Link</button>
        <button class="mybtn" @click="onClickLog">Log</button>
        <button class="mybtn" @click="onClickCustom">Custom button</button>
        <button class="mybtn" @click="onClickPrompt">Prompt</button>
        <button class="mybtn" @click="onClickDouble">doubleConfirm</button>
      </div>
    </div>
  </sui-page-contents>
</sui-page>
</template>

<script>
  export default {
    name: "COMPGUIDE_CONFIRM",
    data() {
      return {
        errorStack: `<div v-if="subMessage !== ''" class="-fdp-messagebox__sub-message-wrapper" :class="classes">
            <div class="-fdp-messagebox__sub-message">{{ subMessage }}</div>
        </div>
        <div v-if="link.url" class="-fdp-messagebox__link-message-wrapper" :class="classes">
            <a class="-fdp-messagebox__link-message" :href="link.url" >{{ link.text }}</a>
        </div>`,
      };
    },
    methods: {
      positiveHandler(text) {
        console.log(`positive`);
      },
      negativeHandler() {
        console.log("negative");
      },
      onClickSuccess() {
        utils.messageBox('success', '저장되었습니다', '다음작업을 진행할수 없습니다', this.positiveHandler);
      },
      onClickWarning() {
        utils.messageBox('warning', '총괄 지역은 필수 항목 입니다', null, this.positiveHandler);
      },
      onClickInformation() {
        utils.messageBox('information', '시스템 사용이 불가능 합니다', '6월 14일(금) 시스템 점검이 있습니다', this.positiveHandler);
      },
      onClickError() {
        utils.messageBox('error', '총괄 지역은 필수 항목 입니다', null, this.positiveHandler);
      },
      onClickErrorLog() {
        utils.messageBox('error', '에러가 발생하였습니다.', {title: 'error id : 99', content: this.errorStack}, this.positiveHandler, this.negativeHandler);
      },
      onClickConfirm() {
        utils.messageBox('confirm', '삭제하시겠습니까?', '총괄 지역은 필수 항목 입니다', this.positiveHandler, this.negativeHandler);
      },
      onClickLink() {
        const link = {text: 'www.sitelink.com', url: 'http://sitelink.com'};
        utils.messageBox('information', '설비 구매처에 대한 정보 입니다', link, this.positiveHandler, this.negativeHandler);
      },
      onClickLog() {
        const logs = [
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
          '대상정보 일괄등록 오류',
        ];
        utils.messageBox('warning', '일괄등록에 오류가 발생했습니다.', logs, this.positiveHandler, this.negativeHandler);
      },
      onClickCustom() {
        const buttons = [
          {
            label: '업무영역1',
            handler: () => {
              console.log('업무영역1');
            }
          },
          {
            label: '업무영역2',
            handler: () => {
              console.log('업무영역2');
            }
          },
        ]
        utils.messageBox('information', '삭제하시겠습니까?', '총괄 지역은 필수 항목 입니다', this.positiveHandler, this.negativeHandler, buttons);
      },
      onClickPrompt() {
        utils.prompt('입력하세요', '기본값', this.positiveHandler, this.negativeHandler);
      },
      onClickDouble() {
        utils.messageBox('confirm', '삭제하시겠습니까?', '총괄 지역은 필수 항목 입니다', () => { this.onClickCustom() }, this.negativeHandler);
      }
    }
  };
</script>
<style scoped>
.mybtn {
  width:100px;
  height: 30px;
  border: 1px solid blue;
}
</style>
